<script lang="ts" setup></script>

<template>
  <div :class="$style.cm">
    <p :class="$style.heading">TVCM</p>
    <iframe
      :class="$style.player"
      src="https://www.youtube.com/embed/qVh5BYxhZOY"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
  </div>
</template>

<style lang="scss" module>
.cm {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 548px;
}

.heading {
  color: $color-text-and-object-high-emphasis;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
}

.player {
  margin-top: 32px;
  width: 100%;
  aspect-ratio: 560 / 315;
}
</style>
